import toString from 'lodash/toString'
import { Link } from 'react-router'
import {
  buildNavPathTrader,
  PERMISSION_ENTITY_INVOICE,
  ROUTE_DOCUMENTS,
  ROUTE_ORDERS,
  ROUTE_PAYABLE
} from '@klear/constants'
import { CalendarQuarter } from '@klear/date/calendar-quarter'
import type { DocumentReference } from '@klear/document/trader-document'

const LINK = 'underline decoration-muted-foreground/40 underline-offset-2 hover:decoration-foreground'

function orderEventPath(traderId: string, reference: Extract<DocumentReference, { kind: 'order_event' }>): string {
  const orderPath = buildNavPathTrader(traderId, ROUTE_ORDERS, toString(reference.orderId))
  if (reference.type === PERMISSION_ENTITY_INVOICE) {
    return buildNavPathTrader(traderId, ROUTE_DOCUMENTS, 'invoice', toString(reference.orderId), toString(reference.id))
  }
  return `${orderPath}?orderEventId=${reference.id}`
}

function ReferenceLink({ traderId, reference }: { traderId: string; reference: DocumentReference }) {
  if (reference.kind === 'financial_statement') {
    return <span>Financial statement · {CalendarQuarter.of(reference.periodEnd).label}</span>
  }
  if (reference.kind === 'payment') {
    return (
      <Link to={buildNavPathTrader(traderId, ROUTE_PAYABLE, toString(reference.id))} className={LINK}>
        {reference.displayId}
      </Link>
    )
  }
  return (
    <span>
      {reference.orderDisplayId !== null && (
        <>
          <Link to={buildNavPathTrader(traderId, ROUTE_ORDERS, toString(reference.orderId))} className={LINK}>
            {reference.orderDisplayId}
          </Link>
          <span className="text-muted-foreground"> · </span>
        </>
      )}
      <Link to={orderEventPath(traderId, reference)} className={LINK}>
        {reference.displayId}
      </Link>
    </span>
  )
}

export function DocumentReferences({ traderId, references }: { traderId: string; references: DocumentReference[] }) {
  if (references.length === 0) return <span className="text-muted-foreground">—</span>
  return (
    <ul className="flex flex-col gap-0.5">
      {references.map((reference) => (
        <li key={`${reference.kind}:${reference.id}`} className="whitespace-nowrap">
          <ReferenceLink traderId={traderId} reference={reference} />
        </li>
      ))}
    </ul>
  )
}
